<!-- 订单列表 -->
<template>
  <div id="kt_post" class="post flex-column-fluid">
    <!--    顶部标题-->
    <TitleCard v-if="!params.wxShopId" style="margin: 10px auto; max-width: 97%" title="提现管理">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">Member Settlement Management</li>
        </ul>
      </template>
    </TitleCard>
    <div
        class="container-fluid d-flex flex-stack flex-column-fluid"
        style="padding: 0 30px"
    >
      <form action="#" style="width: 100%">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card body-->
          <div class="card-body">
            <!--begin::Compact form-->
            <div class="d-flex align-items-center">
              <!--begin::Input group-->
              <div class="position-relative w-md-400px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                <!--end::Svg Icon-->
                <input
                    id="sTitle"
                    v-model="params.userName"
                    class="form-control form-control-solid ps-10"
                    name="shopName"
                    placeholder="用户名"
                    type="text"
                    value=""
                />

              </div>
              <!--end::Input group-->

              <!--begin::Input group-->
              <div class="position-relative w-md-400px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                <!--end::Svg Icon-->
                <input
                    id="sTitle"
                    v-model="params.tel"
                    class="form-control form-control-solid ps-10"
                    name="shopName"
                    placeholder="用户手机号"
                    type="text"
                    value=""
                />

              </div>
              <!--end::Input group-->

              <!--begin:Action-->
              <div class="d-flex align-items-center">
                <div class="btn btn-primary me-5 btn-sm" @click="getList">
                  查询
                </div>
                <div class="btn btn-secondary me-5 btn-sm" @click="resetBtn">
                  重置
                </div>

              </div>

            </div>
          </div>
          <!--end::Card body-->
        </div>
        <!--end::Card-->
      </form>
    </div>
    <div
        id="kt_content_container"
        class="container"
        style="
        margin-top: 10px;
        max-width: 98%;
        flex-direction: row !important;
        display: flex;
      "
    >
      <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
        <div class="d-flex flex-column flex-column-fluid">
          <div id="kt_app_content" class="" style="margin-bottom: 10px">
            <!-- {{idArr}} {{ sumMoney }} -->
            <div class="card card-flush" style="position: relative">
              <div class="card-body">
                <div id="myTabContent" class="tab-content">
                  <div
                      v-loading="loading"
                      class="card mb-5 mb-xl-8"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      element-loading-spinner="el-icon-loading"
                      element-loading-text="拼命加载中"
                      style="margin-left: 3px; width: 100%"
                  >
                    <div class="card-body py-3">
                      <div class="table-responsive">
                        <table
                            id="kt_ecommerce_products_table"
                            class="table align-middle table-row-dashed table-hover fs-6 gy-5 dataTable no-footer"
                        >
                          <thead>
                          <tr
                              class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0"
                          >
                            <th
                                aria-label="order_batch"
                                class="text-center min-w-50px"
                                colspan="1"
                                rowspan="1"
                                style="width: 212.141px"
                                tabindex="0"
                            >
                              用户名
                            </th>
                            <th
                                aria-label="product_name"
                                class="text-center min-w-150px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              用户手机号
                            </th>
                            <th
                                aria-label="market_price"
                                class="text-center min-w-40px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              提现金额
                            </th>
                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              提现时间
                            </th>
                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              提现状态
                            </th>
                            <th
                                aria-label="operation"
                                class="text-center sorting_disabled"
                                colspan="1"
                                rowspan="1"
                                style="width: 120px"
                            >
                              操作
                            </th>
                          </tr>
                          </thead>
                          <tbody class="fw-semibold text-gray-600">
                          <tr
                              v-for="(item, index) in list"
                              :key="index"
                              :class="{ old: index % 2 == 0, even: index % 2 != 0 }"
                          >

                            <td class="text-center pe-0">
                              <span :title="item.userName"
                                  class=""
                                  style="overflow: hidden;
                                  display: -webkit-box;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 3;
                                  line-height: 1.2;">{{ item.userName }}</span>
                            </td>
                            <!-- 商品名称 -->
                            <td class="text-center pe-0">
                              <span :title="item.tel"
                                    class=""
                                    style="overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    line-height: 1.2;">{{ item.tel }}</span>
                            </td>
                            <!-- 市场价 -->
                            <td class="text-center pe-0">
                              <span class="fw-bold">{{ item.money | format }}</span>
                            </td>

                            <!--下单时间-->
                            <td class="text-center pe-0">
                              <span>{{ item.crTime }}</span>
                            </td>
                            <td class="text-center pe-0">
                              <el-tag
                                  v-if="item.type==1"
                                  effect="dark">
                                审核中
                              </el-tag>
                              <el-tag
                                  v-if="item.type==2"
                                  type="success"
                                  effect="dark">
                                通过
                              </el-tag>
                              <el-tag
                                  v-if="item.type==3"
                                  type="danger"
                                  effect="dark">
                                驳回
                              </el-tag>
                            </td>
                            <td style="text-align: center">
                                <el-link @click="handle(item)" type="primary">查看详情</el-link>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <Pagination
                            ref="Pagination"
                            :total-items="totalCount"
                            @page-change="pageChange"
                        ></Pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
        title="提现详情"
        :visible.sync="dialogVisible"
        width="60%"
        >
      <el-descriptions class="margin-top" :column="3" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            用户名
          </template>
          {{ selectedItem.userName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-mobile-phone"></i>
            手机号
          </template>
          {{ selectedItem.tel }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            提现金额
          </template>
          {{ selectedItem.money | format }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            收款方式
          </template>
          {{ selectedItem.cashOutType }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            收款人姓名
          </template>
          {{ selectedItem.name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            收款账号
          </template>
          {{ selectedItem.account}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            开户行
          </template>
          {{ selectedItem.bank }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            提现凭证
          </template>
          <el-upload
              v-if="selectedItem.type==1"
              class="upload-demo"
              accept=".jpeg,.png,.jpg,.bmp,.gif"
              action=""
              :show-file-list="false"
              :http-request="uploadFile"
              >
            <div v-if="fileObj.filePath === ''">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
            </div>
            <div v-else>
              <img :src="fileObj.fileUrl"  style="width: 100%;">
            </div>
          </el-upload>
          <img v-else :src="`https://sjzcsaas.oss-cn-hangzhou.aliyuncs.com${selectedItem.pic}`" alt="" style="width: 100%;">
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer" v-if="selectedItem.type==1">
        <el-button @click="updateStatus(selectedItem.id, 3)">驳 回</el-button>
        <el-button type="success" @click="updateStatus(selectedItem.id, 2)" >同 意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import sd from "silly-datetime";
import {getListApi, updateStatusApi} from "@/api/cashOutApi";
import {uploadFileApi} from "@/api/uploadFileApi";


export default {
  name: "",
  components: {
  },
  // 组件的props定义,用于子组件接收父组件传值
  // 组件的data属性
  data() {
    return {
      selectedItem: {
        crTime:"1",
        id:1,
        money:1,
        pic:"1",
        tel:"",
        type:1,
        userId:'',
        userName:""
      },
      params: {
        current: 1,
        size: 10,
        userName:"",
        tel:"",
      },
      list:[],
      loading:false,
      dialogVisible:false,
      totalCount:0,
      fileObj:{
        "fileUrl": "",
        "filePath": ""
      }


    };
  },
  // 组件的方法
  methods: {
    async uploadFile(file){
      var formData = new FormData();
      formData.append("file", file.file);
      formData.append("moduleName", "duxingxia");
      let{data}= await uploadFileApi(formData)
      this.fileObj=data;
    },
    async updateStatus(id,status){

      this.$confirm(`确认${status==2?'同意':'驳回'}该提现申请?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (status==2 && this.fileObj.fileUrl===""){
          this.$message({
            type: 'info',
            message: '请上传凭证'
          });
          return;
        }

        await updateStatusApi({
          id,status,file:this.fileObj.filePath
        })

        this.$message({
          type: 'success',
          message: `${status==2?'同意':'驳回'}成功！`
        });
       setTimeout(() => {
         this.dialogVisible=false
         this.getList()
       },500)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    handle(item){
      this.fileObj={
        "fileUrl": "",
        "filePath": ""
      }
      this.dialogVisible=true
      this.selectedItem=item
    },
    pageChange(currentPage, pageSize) {
      this.params.current = currentPage;
      this.params.size = pageSize;
      this.getList();
    },
    async getList(){
      this.loading=true
      let {data}=await getListApi(this.params)
      this.list=data.rows
      this.loading=false
      this.totalCount = data.total
    },
    resetBtn() {
      this.params = {
        current: 1,
        size: 10,
        userName:""
      };
      this.getList();
    },
  },
  // 在created钩子中执行的操作
  created() {
    this.getList();

  },
  filters: {
    dataFormat(date) {
      return sd.format(date, "YYYY-MM-DD HH:mm:ss");
    },
    format(num) {
      return (
          Number(num)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,") + " 元"
      );
    },
  },
};
</script>

<!-- 组件的样式 -->
<style scoped>
.el-range-separator {
  padding: 0;
}
</style>
